import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "page-container" };
import OneDeskCard from "@/components/molecules/OneDeskCard.vue";
import UpsertWebSite from "@/components/templates/BackOffice/forms/inventory/UpsertWebSite.vue";
import { useRouter } from "vue-router";
export default /*#__PURE__*/ _defineComponent({
    __name: 'AddWebSite',
    setup(__props) {
        const router = useRouter();
        const goToWebSitesAdmin = () => {
            router.push({ name: "AdminWebsites" });
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(OneDeskCard, {
                    "has-filters": false,
                    title: "Add website"
                }, {
                    content: _withCtx(() => [
                        _createVNode(UpsertWebSite, {
                            "full-screen": true,
                            onWebsiteUpdated: goToWebSitesAdmin
                        })
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
